/* Utils */
import { generateEntityActionTypes } from '../utils/generators/actionTypeGenerators';

const ENTITY_NAME = 'CAROUSELS';

export const FETCH_CAROUSEL = `${ENTITY_NAME}/FETCH/CAROUSEL`;
export const CAROUSEL_ENTITY_ACTION_TYPES = generateEntityActionTypes(ENTITY_NAME);
